/**
 * Vanilla Carousel — Replaces Slick
 * Lightweight carousel with autoplay, arrows, dots, fade, and responsive support
 */
(function() {
  'use strict';

  function Carousel(container, options) {
    if (!container) return;

    var defaults = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 300,
      fade: false,
      pauseOnHover: true,
      responsive: []
    };

    this.container = container;
    this.options = Object.assign({}, defaults, options);
    this.currentSlide = 0;
    this.autoplayTimer = null;
    this.slides = Array.from(container.children);
    this.totalSlides = this.slides.length;

    if (this.totalSlides <= 1) {
      container.classList.add('carousel-single');
      return;
    }

    this.init();
  }

  Carousel.prototype.init = function() {
    this.wrap();
    this.createControls();
    this.applyResponsive();
    this.goTo(0, true);
    this.bindEvents();

    if (this.options.autoplay) {
      this.startAutoplay();
    }

    this.container.classList.add('carousel-initialized');
  };

  Carousel.prototype.wrap = function() {
    var wrapper = document.createElement('div');
    wrapper.className = 'carousel-wrapper';

    var track = document.createElement('div');
    track.className = 'carousel-track';
    track.style.transition = 'transform ' + this.options.speed + 'ms ease';

    this.slides.forEach(function(slide) {
      slide.classList.add('carousel-slide');
      track.appendChild(slide);
    });

    wrapper.appendChild(track);
    this.container.appendChild(wrapper);

    this.wrapper = wrapper;
    this.track = track;

    if (this.options.fade) {
      this.container.classList.add('carousel-fade');
    }
  };

  Carousel.prototype.createControls = function() {
    if (this.options.arrows) {
      var prevBtn = document.createElement('button');
      prevBtn.className = 'carousel-prev';
      prevBtn.innerHTML = '&#8592;';
      prevBtn.setAttribute('aria-label', 'Previous slide');

      var nextBtn = document.createElement('button');
      nextBtn.className = 'carousel-next';
      nextBtn.innerHTML = '&#8594;';
      nextBtn.setAttribute('aria-label', 'Next slide');

      this.container.appendChild(prevBtn);
      this.container.appendChild(nextBtn);

      this.prevBtn = prevBtn;
      this.nextBtn = nextBtn;
    }

    if (this.options.dots) {
      var dotsContainer = document.createElement('div');
      dotsContainer.className = 'carousel-dots';

      var pageCount = Math.ceil(this.totalSlides / this.getEffectiveOption('slidesToScroll'));
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.className = 'carousel-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('data-slide', i * this.getEffectiveOption('slidesToScroll'));
        dotsContainer.appendChild(dot);
      }

      this.container.appendChild(dotsContainer);
      this.dotsContainer = dotsContainer;
    }
  };

  Carousel.prototype.bindEvents = function() {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function() {
        self.prev();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function() {
        self.next();
      });
    }

    if (this.dotsContainer) {
      this.dotsContainer.addEventListener('click', function(e) {
        var dot = e.target.closest('.carousel-dot');
        if (dot) {
          self.goTo(parseInt(dot.getAttribute('data-slide')));
        }
      });
    }

    if (this.options.pauseOnHover) {
      this.container.addEventListener('mouseenter', function() {
        self.stopAutoplay();
      });
      this.container.addEventListener('mouseleave', function() {
        if (self.options.autoplay) self.startAutoplay();
      });
    }

    // Handle resize for responsive
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        self.applyResponsive();
        self.goTo(self.currentSlide, true);
      }, 150);
    });
  };

  Carousel.prototype.getEffectiveOption = function(key) {
    return this._effectiveOptions ? (this._effectiveOptions[key] || this.options[key]) : this.options[key];
  };

  Carousel.prototype.applyResponsive = function() {
    var width = window.innerWidth;
    this._effectiveOptions = {};

    // Sort responsive breakpoints descending
    var sorted = this.options.responsive.slice().sort(function(a, b) {
      return b.breakpoint - a.breakpoint;
    });

    for (var i = 0; i < sorted.length; i++) {
      if (width <= sorted[i].breakpoint && sorted[i].settings) {
        this._effectiveOptions = sorted[i].settings;
        break;
      }
    }

    // Update slide widths
    var toShow = this.getEffectiveOption('slidesToShow');
    this.slides.forEach(function(slide) {
      slide.style.minWidth = (100 / toShow) + '%';
      slide.style.maxWidth = (100 / toShow) + '%';
    });
  };

  Carousel.prototype.goTo = function(index, instant) {
    var toShow = this.getEffectiveOption('slidesToShow');
    var maxIndex = Math.max(0, this.totalSlides - toShow);
    this.currentSlide = Math.max(0, Math.min(index, maxIndex));

    if (this.options.fade) {
      this.slides.forEach(function(slide, i) {
        slide.classList.toggle('carousel-slide-active', i === this.currentSlide);
      }.bind(this));
    } else {
      var offset = -(this.currentSlide * (100 / toShow));
      this.track.style.transition = instant ? 'none' : 'transform ' + this.getEffectiveOption('speed') + 'ms ease';
      this.track.style.transform = 'translateX(' + offset + '%)';
    }

    this.updateDots();
  };

  Carousel.prototype.next = function() {
    var toScroll = this.getEffectiveOption('slidesToScroll');
    var toShow = this.getEffectiveOption('slidesToShow');
    var maxIndex = Math.max(0, this.totalSlides - toShow);

    if (this.currentSlide >= maxIndex) {
      this.goTo(0);
    } else {
      this.goTo(this.currentSlide + toScroll);
    }
  };

  Carousel.prototype.prev = function() {
    var toScroll = this.getEffectiveOption('slidesToScroll');
    var toShow = this.getEffectiveOption('slidesToShow');
    var maxIndex = Math.max(0, this.totalSlides - toShow);

    if (this.currentSlide <= 0) {
      this.goTo(maxIndex);
    } else {
      this.goTo(this.currentSlide - toScroll);
    }
  };

  Carousel.prototype.updateDots = function() {
    if (!this.dotsContainer) return;
    var toScroll = this.getEffectiveOption('slidesToScroll');
    var activePage = Math.floor(this.currentSlide / toScroll);

    this.dotsContainer.querySelectorAll('.carousel-dot').forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === activePage);
    });
  };

  Carousel.prototype.startAutoplay = function() {
    var self = this;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(function() {
      self.next();
    }, this.getEffectiveOption('autoplaySpeed'));
  };

  Carousel.prototype.stopAutoplay = function() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  };

  // Auto-init carousels with data-carousel attribute
  function initAll() {
    document.querySelectorAll('[data-carousel]').forEach(function(el) {
      if (el.classList.contains('carousel-initialized')) return;
      var opts = {};
      try {
        opts = JSON.parse(el.getAttribute('data-carousel'));
      } catch(e) {}
      new Carousel(el, opts);
    });
  }

  // Public
  window.Carousel = Carousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
